module.exports = __webpack_public_path__ + "img/3.aa8b11f9.png";